
import { Component, Mixins } from "vue-property-decorator";
import { CheckStyle } from "../../../../../../documaker/domain/format/objects";
import { ICheckStylePropertyEditable, instanceOfICheckStylePropertyEditable } from "../../../../../domain/editableFormat/properties";

@Component
export default class CheckStylePropertyEditableMixin extends Mixins() {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: ICheckStylePropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: ICheckStylePropertyEditable) => T, defaultValue: T) => T;

  // ドメイン層のエンティティは全てinterfaceにしてるが、
  // 本体のコンポーネントは従来のクラスエンティティで実装されてるのでそっちに合わせないと既存部品を再利用できない。
  // Vueの世界の話なのでコンポーネント側の実装で吸収する。

  get isCheckStyleEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfICheckStylePropertyEditable(s) && s.checkStyle().isEditable(), false);
  }

  get checkStyle(): CheckStyle {
    return this.readPropertyOrDefault(s => CheckStyle.from(s.checkStyle().getValue()), new CheckStyle());
  }

  set checkStyle(value: CheckStyle) {
    this.writePropertyWhenValid(s => s.checkStyle().setValue(CheckStyle.to(value)));
  }
}
